window.$ = window.jQuery = require('jquery');

require('@coreui/coreui');
require('@coreui/coreui/js/dist/tab');
require('@coreui/coreui/js/dist/tooltip');
require('@coreui/coreui/js/dist/modal');

console.log('frontend');
